<template>
<!-- 	<div class='knd-loader'>
		Laden
	</div>
 -->
	<div>
		<Story />
	</div>
</template>

<script>
import Story from './components/story/story';

import './scss/index.scss'

export default {
	name: 'App',
	mounted: function() {},
	components: {
		Story
	}
}
</script>
